module.exports = __webpack_public_path__ + "img/12-6.675de584.png";